import { RemoveRedEye } from "@mui/icons-material";
import DropZone from "../../../commons/dropZone/DropZone";
import FeatureLabel from "../commons/labels/FeatureLabel";

const ImportarNominaDropZone = ({
  handleViewInstruccionesImportar,
  setNominasCsv,
  nominasCsv,
}) => {
  return (
    <div>
      <FeatureLabel
        labelText="INFORMACIÓN DEL ARCHIVO A IMPORTAR"
        icon={<RemoveRedEye />}
        onClick={handleViewInstruccionesImportar}
        tooltipText="Ver Información"
      />
      <DropZone
        file={nominasCsv}
        setFile={setNominasCsv}
        loading={false}
        maxFiles={1}
        colorearArchivosAdjuntos={true}
        extension=".xlsx .xls"
        accept={{
          "application/vnd.ms-excel": [".xls", ".xlsx"],
        }}
        dropZoneText="Arrastre la nómina en formato .xlsx o .xls aquí. O haga click en el recuadro para
    adjuntarla."
        dropZoneEditText="Si desea cambiar el archivo arrástrelo nuevamente o haga click en
    el recuadro."
      />
    </div>
  );
};

export default ImportarNominaDropZone;
